import {
  INICIALITZAR,
  INTRODUCCIO_OMPLIR_ID_OBSERVADOR,
  OBTENIR_OBSERVADORS,
  OMPLIR_USUARI_AUTENTICAT
} from "../../actions/actionTypes";

const ESTAT_INICIAL = null;

const idObservador = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case OMPLIR_USUARI_AUTENTICAT: {
      const usuariAutenticat = action.payload;
      if (usuariAutenticat.idObservador && !state) {
        return usuariAutenticat.idObservador;
      } else return state || ESTAT_INICIAL;
    }
    case INTRODUCCIO_OMPLIR_ID_OBSERVADOR:
      return action.payload;

    case `${OBTENIR_OBSERVADORS}_SUCCESS`: {
      const observadors = action.payload;
      const idObservadorSeleccionat = state;

      if (
        observadors &&
        idObservadorSeleccionat &&
        observadors[idObservadorSeleccionat]
      ) {
        return idObservadorSeleccionat;
      }

      const idsObservadors = observadors ? Object.keys(observadors) : [];

      if (idsObservadors.length === 0) {
        return ESTAT_INICIAL;
      }

      return idObservadorSeleccionat;
    }
    default:
      return state;
  }
};

export default idObservador;

export const getIdObservador = state => state;
